import dayjs from 'dayjs';

export function getSubscriptionStatus(subscriptionDate?: Date): { status: string; color: string } {
  if (!subscriptionDate) {
    return { status: '', color: '' };
  }

  const now = dayjs();
  const subDate = dayjs(subscriptionDate);
  const diffInDays = subDate.diff(now, 'day');

  if (subDate.isBefore(now)) {
    return { status: `Nieaktywny od ${formatDate(subDate)}`, color: '#9CA3AF' };
  }

  if (diffInDays <= 3) {
    return { status: `Aktywny do ${formatDate(subDate)}`, color: '#F97316' };
  }

  return { status: `Aktywny do ${formatDate(subDate)}`, color: '#22C55E' };
}

function formatDate(date: dayjs.Dayjs): string {
  return date.format('DD.MM.YYYY');
}